import { useState } from "react";
/**
 * Custom hook for managing table sorting with visual arrow indicators.
 * @param {string} initialKey - The initial sort key.
 * @param {string} initialDirection - The initial sort direction ('asc' or 'desc').
 * @returns {Object} Object containing sortConfig, setSortConfig, and renderSortArrow function.
 */
export const SortDirections = {
    ASCENDING: 'asc',
    DESCENDING: 'desc',
};

export const useTableSort = (initialKey, initialDirection) => {
    const [sortConfig, setSortConfig] = useState({
        key: initialKey,
        direction: initialDirection,
    });

    const resetSortConfig = () => {
        setSortConfig({
            key: initialKey,
            direction: initialDirection,
        });
    };

    const handleSort = (key) => {
        setSortConfig((prevConfig) => {
            if (prevConfig.key === key) {
                return {
                    key,
                    direction:
                        prevConfig.direction === SortDirections.ASCENDING
                            ? SortDirections.DESCENDING
                            : SortDirections.ASCENDING,
                };
            }
            return {
                key,
                direction: SortDirections.DESCENDING,
            };
        });
    };

    const renderSortArrow = (column) => {
        const isActive = sortConfig.key === column;
        const isDescending = sortConfig.direction === SortDirections.DESCENDING;

        return (
            <span
                onClick={() => handleSort(column)}
                style={{ cursor: 'pointer' }}
                className="px-2"
            >
                <svg width={11} height={6} viewBox="0 0 11 6" fill="none">
                    <path
                        transform={
                            isActive && isDescending ? 'rotate(180 5.25 3)' : ''
                        }
                        d="M1 0.75L5.25 5.25L9.5 0.75"
                        stroke="#2F2B43"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </span>
        );
    };

    return { sortConfig, setSortConfig, resetSortConfig, renderSortArrow };
};